﻿const ExcursionsSearchBox = class {
    constructor(t, options = {}) {
        options = options || {};
        this.specificProductId = options.specificProductId;
        this.specificDateId = options.specificDateId;

        this.target = t;
        this.form = this.target.querySelector("form");

        this.productLargeSelect = this.target.querySelector("[data-attraction-filter=products] [data-select-type=list]");
        this.selectedProduct = "";
        this.datesLargeSelect = this.target.querySelector("[data-attraction-filter=dates] [data-select-type=list]");
        this.productOptions = [];
        this.datesOptions = [];
        this.productSelect = {};

        this.form.addEventListener('submit', this.submit.bind(this));
    }

    createPayload() {
        let passengerTypes = this.target.querySelectorAll('[name=passengerType]');
        
        return Promise.resolve({
            productId: parseInt(this.form.productId.value),
            dateId: parseInt(this.form.dates.value),
            selectedDate: this.form.dates.options[this.form.dates.selectedIndex].text,
            passengers: [].filter.call(passengerTypes, (element) => element.value !== "0")
                .map(element => ({ id: element.dataset.id, value: element.value }))
        });
    }
    
    ValidateInfant(errors) {
        const infantId = document.querySelector("[data-infant-id]")?.dataset.infantId;
        const adultIds = document.querySelector("[data-adult-ids]")?.dataset.adultIds;

        if (!infantId || !adultIds) {
            return;
        }
        
        const infantAmount = searchBoxes.passengers.getSelectedForTypeId(this.form, infantId).value;
        const adultAmount = searchBoxes.passengers.getSelectedForTypeArrayId(this.form, adultIds.split(','))
            .map(passengerType => passengerType.value)
            .reduce((a, b) => parseInt(a) + parseInt(b), 0);

        if (infantAmount > 0 && adultAmount <= 0){
            const message = this.form.dataset.infantValidationMessage;
            errors.push(message);
        }
    }

    ValidatePayload(search) {
        let errors = [];
        
        this.ValidateInfant(errors);
        
        if (!search.passengers.length) {
            errors.push("Please select at least 1 passenger.");
        }

        return errors;
    }

    CheckValidation() {
        this.createPayload()
            .then(payload => this.ValidatePayload(payload))
            .then(errors => this.ShowErrors(errors));
    }

    ShowErrors(errors) {
        let area = this.target.querySelector(".search-form__validation-area");

        area.innerHTML = "";
        errors.forEach(error => {
            let message = document.createElement("p");
            message.innerText = error;
            area.appendChild(message);
        });

        area.style.display = area.innerHTML === "" ? "none" : "block";

        return errors;
    }

    submit() {
        event.preventDefault();

        this.createPayload()
            .then(payload => {
                localStorage.currentSearch = JSON.stringify(payload);
                localStorage.currentSearchType = "excursionresults";

                this.form.searchPayload.value = JSON.stringify(payload);

                return payload;
            })
            .then(payload => this.ValidatePayload(payload))
            .then(errors => this.ShowErrors(errors))
            .then(errors => {
                if (!errors.length) {
                    Utilities.ShowLoader();
                    this.form.submit();
                }
            });
    }

    get(uri) {
        return window.fetch(uri)
            .then(response => response.json());
    }

    bindProducts(products, selectedId = 0) {
        return Promise.resolve(typeof selectedId === "undefined" ? parseInt(this.form.productId.value) : selectedId)
            .then(id => products.filter(x => x.Id == id).length ? id : products.length ? products[0].Id : 0)
            .then(id => {
                return {
                    keyValues: products.map(x => {
                        return {
                            key: x.Id,
                            value: x.Name + "/SPLIT\"" + x.locationName
                        };
                    }),
                    selectedId: id
                };
            })
            .then(data => searchBoxes.formWrappers.bindList(this.form.productId, data.keyValues, data.selectedId))
            .then(_ => {
                let products = document.querySelectorAll("[data-excursionssearchbox] [name=productId]")[1].childNodes;
                if (products.length > 0) {
                    products.forEach((element) => {
                        let split = element.innerText.split("/SPLIT\"");
                        element.dataset["textvalue"] = split[1] + "<span class='icon'>→</span>" + split[0];
                    });
                }
            
        });
    }

    bindDates(dates, selectedId = 0) {
        return Promise.resolve(typeof selectedId === "undefined" ? parseInt(this.form.dates.value) : selectedId)
            .then(id => dates.filter(x => x.id == id).length ? id : dates.length ? dates[0].Id : 0)
            .then(id => {
                return {
                    keyValues: dates.map(x => {
                        return {
                            key: x.Id,
                            value: x.Value
                        };
                    }),
                    selectedId: id
                };
            })
            .then(data => searchBoxes.formWrappers.bindList(this.form.dates, data.keyValues, data.selectedId));
    }

    loadProducts() {
        return this.get("/api/data/Excursions")
            .then(products => {
                if (this.specificProductId) {
                    var filtered = products.filter(x => x.Id == this.specificProductId);

                    if (filtered.length == 1) {
                        return filtered;
                    }
                }
                return products;
            })
            .then(products => {
                this.productOptions = products;

                return this.bindProducts(products)
                    .then(_ => {
                        this.selectedProduct = products[0].Id;
                        if (products.length == 1) {
                            this.form.productId.disabled = true;
                            this.productLargeSelect.querySelector(".large-select__icon").style.display = "none";
                            this.productLargeSelect.querySelector(".large-select__value").innerHTML =
                                products[0].Name;
                            
                        } else {
                            this.productSelect = new LargeSelectList(this.productLargeSelect);
                        }
                    });
            });
    }

    loadDates() {
        return this.get(`/api/data/ExcursionsDates?id=${this.selectedProduct}`)
            .then(dates => {
                if (this.specificDateId) {
                    var filtered = dates.filter(x => x.Id == this.specificDateId);

                    if (filtered.length == 1) {
                        return filtered;
                    }
                }
                return dates.filter(date => 0 > moment().diff(moment(date.Value, "DD/MM/YYYY hh:mm")));
            })
            .then(dates => {
                this.datesOptions = dates;

                return this.bindDates(dates)
                    .then(_ => {
                        if (dates.length == 1) {
                            this.form.dates.disabled = true;
                            this.datesLargeSelect.querySelector(".large-select__icon").style.display = "none";
                            this.datesLargeSelect.querySelector(".large-select__value").innerHTML =
                                dates[0].Value;
                        } else {
                            this.datesSelect = new LargeSelectList(this.datesLargeSelect);
                        }
                    });
            });
    }

    getDateTimeContainer() {
        return this.form.querySelector("[data-attraction-filter=travelDate]");
    }

    Initialise() {
        return this.loadProducts()
            .then(_ => this.loadDates())
            .then(_ => {
                this.paxSelect = new LargeSelectPax(this.target.querySelector("[data-attraction-filter=pax] [data-select-type=pax]"));

                this.target.querySelector('[data-loader]').remove();
                this.target.querySelector('form').style.display = 'block';

                document.querySelectorAll("[data-excursionssearchbox] [name=productId]")[1].addEventListener("change", () => {
                        this.selectedProduct = document.querySelectorAll("[data-excursionssearchbox] [name=productId]")[1].value;
                        this.loadDates();
                    });

                SearchBoxValidationCallback.addListener("Product",
                    () => {
                        this.CheckValidation();
                    });
            });
    }

    bind(model) {
        
    }
};

function bookNowExcursionSearch(target, productId) {
    let searchBox = new ExcursionsSearchBox(target,
        {
            specificProductId: productId
        });
    return searchBox.Initialise();
}
